var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChiliNoLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.2832cm",
    height: "0.8087cm",
    viewBox: "0 0 36.3749 22.9247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fc3c65;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.5054,7.2432A7.0588,7.0588,0,0,0,32.6527,2.53a7.0633,7.0633,0,0,0-4.1311-1.4254V1.1024h-.0022V1.101H11.018v0h-.1765q-.0909,0-.1816.001H10.648v0a6.373,6.373,0,0,0-.79.0506A10.609,10.609,0,0,0,5.5993,2.677,10.1677,10.1677,0,0,0,1.3681,7.9941,10.3424,10.3424,0,0,0,.84,12.6567,10.2522,10.2522,0,0,0,1.844,16.1974a9.7145,9.7145,0,0,0,6.0136,5.0135,15.1571,15.1571,0,0,0,3.4319.6118c.12.01.1153-.0534.1131-.1327a4.9618,4.9618,0,0,1,.0794-1.1072,5.8774,5.8774,0,0,1,2.9388-4.0648,6.5529,6.5529,0,0,1,3.2206-.8771h9.7514V15.64l.84,0a7.3287,7.3287,0,0,0,.9981-.0614,7.1175,7.1175,0,0,0,4.9884-2.965A7.01,7.01,0,0,0,35.5054,7.2432Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.8378,19.9448V18.5405c0-.3965-.1523-.63-.4541-.63-.2031,0-.5224.0938-.5224.666v1.3682h-.5986V18.5405c0-.374-.1661-.63-.4952-.63-.3193,0-.4814.2022-.4814.7608v1.2734h-.5986v-2.498h.5488v.2109h.0088a.7379.7379,0,0,1,.6533-.2969.8309.8309,0,0,1,.72.3916.9128.9128,0,0,1,.8057-.3916.9689.9689,0,0,1,1.0137,1.08v1.5039Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.788,18.6977a1.3368,1.3368,0,0,1,1.3331-1.3369,1.3178,1.3178,0,0,1,1.3232,1.3281,1.3038,1.3038,0,0,1-1.3232,1.337A1.34,1.34,0,0,1,19.788,18.6977Zm2.0577.0049a.7318.7318,0,1,0-1.459-.0049.7309.7309,0,1,0,1.459.0049Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.7685,19.9448V16.6137h.5986v1.0577a1.1173,1.1173,0,0,1,.7784-.3106,1.3353,1.3353,0,0,1,.0136,2.6651,1.0054,1.0054,0,0,1-.8418-.3829v.3018Zm2.0342-1.2559a.7416.7416,0,0,0-.7334-.7783.75.75,0,0,0-.7383.751.7662.7662,0,0,0,.752.8154A.7288.7288,0,0,0,24.8027,18.6889Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.7656,17.1626v-.5489h.5986v.5489Zm0,2.7822v-2.498h.5986v2.498Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.8505,19.9448V16.6137h.5987v3.3311Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.8564,10.2934A4.4422,4.4422,0,0,1,10.833,12.894,4.5942,4.5942,0,0,1,6.2919,8.33a4.5419,4.5419,0,0,1,4.5059-4.4942,4.4713,4.4713,0,0,1,4.1055,2.6582h-1.835a2.9667,2.9667,0,0,0-2.33-1.1523A3,3,0,0,0,7.9033,8.353a3.04,3.04,0,0,0,2.8945,3.0352,2.7566,2.7566,0,0,0,2.1875-1.0948Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.9238,12.7173v-3.4c0-1.3526-.4463-1.917-1.3408-1.917s-1.3174.6347-1.3174,1.9414v3.376H15.7011V4.0112h1.5645V6.647A2.3346,2.3346,0,0,1,18.96,5.9643,2.569,2.569,0,0,1,21.4892,8.729v3.9883Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.7451,5.4468V4.0112h1.5654V5.4468Zm0,7.2705V6.188h1.5654v6.5293Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.581,12.7173V4.0112h1.5645v8.7061Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.3906,5.4468V4.0112H29.956V5.4468Zm0,7.2705V6.188H29.956v6.5293Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChiliNoLogoSmall);
export default __webpack_public_path__ + "static/media/ChiliNoLogoSmall.44da706291ab0a65078e0c63ed2d3217.svg";
export { ForwardRef as ReactComponent };